import axios, { AxiosInstance } from "axios";
import jwtService from "@/app/services/jwt.service";
import { touchSession } from "@/composables/tokenRefresh";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://obrs-api.ursb.go.ug'

export const api = (ip?: string): AxiosInstance => {
  const baseURL = ip != null ? ip : API_BASE_URL

  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + jwtService.getToken()
    }
  })

  instance.interceptors.request.use(
    (config) => {
      if (config.data instanceof FormData && config.headers) {
        delete config.headers['Content-Type']
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response !== undefined && (error.response.status === 401)) {
        localStorage.clear()
        sessionStorage.clear()
        touchSession()
        alert('session expired, please login again to continue')
        window.location.reload()
      }
      return Promise.reject(error)
    }
  )

  return instance
}

export const authApi = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
  })

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response !== undefined && (error.response.status === 401)) {
        localStorage.clear()
        sessionStorage.clear()
        touchSession()
        alert('session expired , please login again to continue')
        window.location.reload()
      }
      return Promise.reject(error)
    }
  )

  return instance
}

export default { authApi, api }
